import { createFileRoute, Outlet } from "@tanstack/react-router";
import { guardRoute } from "@/lib/policy/route-guard";

export const Route = createFileRoute("/_authenticated/_pharmacy/med-pass")({
  beforeLoad: ({ context }) => guardRoute(context.me, "med-pass"),
  component: Outlet,
});
